{
  "version": 1,
  "fixtures": [
    {
      "id": "add-lunch-with-ruth-and-notify-gil",
      "claimedUserRequest": "Add lunch with Ruth next Tuesday at noon and let Gil know.",
      "calendar": {
        "kind": "create",
        "eventId": "b7c0ffee12345",
        "title": "Lunch with Ruth",
        "startTime": "2026-07-21T18:00:00.000Z",
        "endTime": "2026-07-21T19:00:00.000Z",
        "timeZone": "America/Denver"
      },
      "familyNotification": {
        "installationId": "sandbox-installation",
        "contactId": "sandbox-contact-gil",
        "pairingRevision": "bbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbb",
        "displayLabel": "Gil",
        "document": {
          "kind": "calendar_creation",
          "eventTitle": "Lunch with Ruth",
          "startTime": "2026-07-21T18:00:00.000Z",
          "endTime": "2026-07-21T19:00:00.000Z",
          "timeZone": "America/Denver"
        }
      }
    },
    {
      "id": "cancel-dentist-and-notify-gil",
      "claimedUserRequest": "Remove my dentist appointment from the calendar and let Gil know.",
      "calendar": {
        "kind": "cancel",
        "eventId": "event-dentist",
        "expectedEtag": "event-dentist-r1"
      },
      "familyNotification": {
        "installationId": "sandbox-installation",
        "contactId": "sandbox-contact-gil",
        "pairingRevision": "cccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccc",
        "displayLabel": "Gil",
        "document": {
          "kind": "calendar_cancellation",
          "eventTitle": "Dentist appointment",
          "startTime": "2026-07-23T19:00:00.000Z",
          "endTime": "2026-07-23T20:00:00.000Z",
          "timeZone": "America/Denver"
        }
      }
    },
    {
      "id": "move-demo-appointment-and-notify-gil",
      "claimedUserRequest": "Move Bander Demo Appointment to July 18 at 4 PM and let my son know.",
      "calendar": {
        "kind": "reschedule",
        "eventId": "event-demo-appointment",
        "expectedEtag": "event-demo-appointment-r1",
        "newStartTime": "2026-07-18T16:00:00-06:00"
      },
      "familyNotification": {
        "installationId": "sandbox-installation",
        "contactId": "sandbox-contact-gil",
        "pairingRevision": "aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa",
        "displayLabel": "Gil",
        "document": {
          "kind": "calendar_transition",
          "eventTitle": "Bander Demo Appointment",
          "newStartTime": "2026-07-18T22:00:00.000Z",
          "newEndTime": "2026-07-18T23:00:00.000Z",
          "timeZone": "America/Denver"
        }
      }
    },
    {
      "id": "move-dinner-and-notify-sarah",
      "claimedUserRequest": "Move dinner with Sarah to 7:30 and tell her I’ll be 20 minutes late.",
      "calendar": {
        "kind": "reschedule",
        "eventId": "event-dinner-sarah",
        "expectedEtag": "event-dinner-sarah-r1",
        "newStartTime": "2026-07-14T19:30:00-06:00"
      },
      "message": {
        "recipientId": "person-sarah",
        "expectedRecipientRevision": 1,
        "body": "I’ll be about 20 minutes late. See you at 7:30!"
      }
    },
    {
      "id": "move-my-focus-block",
      "claimedUserRequest": "Move my focus block to 10:30.",
      "calendar": {
        "kind": "reschedule",
        "eventId": "event-focus-block",
        "expectedEtag": "event-focus-block-r1",
        "newStartTime": "2026-07-15T10:30:00-06:00"
      }
    },
    {
      "id": "move-dinner-under-standing-band",
      "claimedUserRequest": "Move dinner with Sarah to 7:30.",
      "calendar": {
        "kind": "reschedule",
        "eventId": "event-dinner-sarah",
        "expectedEtag": "event-dinner-sarah-r1",
        "newStartTime": "2026-07-14T19:30:00-06:00"
      }
    }
  ]
}
